import { CircularProgressbar } from 'react-circular-progressbar';
import styled from 'styled-components';

export const UnityLoaderWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  color: white;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
  font-size: 3rem;
  svg {
    width: 12rem;
    height: 12rem;
    margin: auto;
  }
`;

export const LoadingAssetsText = styled.div`
  font-size: 2rem;
`;
